import groupActionApi from "../../../api/group_action";

const getGroupActionByAutomationActionId = (context, groupActionId) => {
  if (context.getters.hasGroupActionByAutomationActionId(groupActionId)) {
    return Promise.resolve(context.getters.getGroupActionByAutomationActionId(groupActionId));
  }

  context.commit("SET_FETCHING_GROUP_ACTION_IDS", [groupActionId]);

  return groupActionApi.getGroupActionByAutomationActionId(groupActionId)
    .then((groupAction) => {
      context.commit("UNSET_FETCHING_GROUP_ACTION_IDS", [groupActionId]);
      context.commit("CACHE_GROUP_ACTION", groupAction);

      return groupAction;
    });
};

export default {
  getGroupActionByAutomationActionId,
};
